export const formatPrice = (price: number) => `$${price}`